import hostedOpenText from "public/application-services/icons/hosted-open-text.png";
import { ContentCard } from "@/components/contentCard";

export const HOSTED_OPEN_TEXT_NOM_FEATURES = {
  title: "Features of Hosted OpenText NOM",
  list: [
    {
      image: hostedOpenText,
      title: "Advanced Network Monitoring & Centralized Management",
      content: (
        <ContentCard
          points={[
            "Real-time insights & AI-powered analytics to detect and resolve issues proactively.",
            "End-to-end visibility across cloud and hybrid infrastructures.",
            "Single-pane-of-glass dashboard with real-time alerts and IT tool integration.",
          ]}
        />
      ),
    },
    {
      image: hostedOpenText,
      title: "Intelligent Automation & Workflow Optimization",
      content: (
        <ContentCard
          points={[
            "Automates routine tasks like configuration, patching, and updates.",
            "Minimizes human error while enhancing efficiency.",
            "Event-driven automation for instant incident response.",
          ]}
        />
      ),
    },
    {
      image: hostedOpenText,
      title: "Security & Compliance Assurance",
      content: (
        <ContentCard
          points={[
            "Monitors & enforces compliance with industry standards (ISO, NIST, CIS).",
            "Automated audit logs & reports for regulatory needs.",
            "Real-time vulnerability detection for unauthorized network changes.",
          ]}
        />
      ),
    },
    {
      image: hostedOpenText,
      title: "Cloud Scalability & Cost Savings",
      content: (
        <ContentCard
          points={[
            "Fully cloud-hosted with no on-premises hardware required.",
            "Pay-as-you-grow model for flexible resource scaling.",
            "Reduced CAPEX & OPEX costs compared to traditional solutions.",
          ]}
        />
      ),
    },
  ],
};
